import {BrowserRouter} from 'react-router-dom';
import {createRoot} from 'react-dom/client';
import App from './App';
import {Provider} from 'react-redux';
import {persistor, store} from './store/Store';
import {PersistGate} from 'redux-persist/integration/react';
import {AppInsightsContext} from '@microsoft/applicationinsights-react-js';
import {init} from '@fullstory/browser';
import {reactPlugin} from './services/analytics/appInsights';
import {ThemeProvider} from 'pepsico-ds';
import 'pepsico-ds/css';
import './index.css';

const container = document.getElementById('root');
const root = createRoot(container!); // createRoot(container!) if you use TypeScript

init({
  orgId: process.env.REACT_APP_FULLSTORY_ORG_ID || 'default_fallback_id',
  debug: false,
});
root.render(
  <Provider store={store}>
    <PersistGate
      loading={null}
      persistor={persistor}
    >
      <AppInsightsContext.Provider value={reactPlugin}>
        <ThemeProvider>
          <BrowserRouter>
            <App />
          </BrowserRouter>
        </ThemeProvider>
      </AppInsightsContext.Provider>
    </PersistGate>
  </Provider>,
);
